module.exports = __webpack_public_path__ + "static/media/vehicle-chassis.bae10c33.mp4";